import { useEffect } from 'react'
import { useAuthStore } from './stores/auth'
import LoginPage from './pages/LoginPage'
import SetupPage from './pages/SetupPage'
import DashboardPage from './pages/DashboardPage'

export default function App() {
  const { status, checkAuth } = useAuthStore()
  useEffect(() => { checkAuth() }, [checkAuth])

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-400 text-sm">
        読込中...
      </div>
    )
  }
  if (status === 'setup') return <SetupPage />
  if (status === 'login') return <LoginPage />
  return <DashboardPage />
}
